import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { ValidatorFn, FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgxPermissionsService, NgxRolesService } from 'ngx-permissions';

//import constants
import { AppFrontRoutes } from '../../../../../constants/app-front-routes';

//import validators
import { ValidateExtension } from '../../../../../validators/extension.validator';

//import services
import { GeneralService } from '../../../../../services/general.service';
import { DeadlineService } from '../../../../../services/deadline.service';
import { DocumentMangService } from '../../../../../services/document_mang.service';

declare var $: any;


const MyAwesomeRangeValidator: ValidatorFn = (fg: FormGroup) => {
  const repeat_period = fg.get('repeat_period').value;
  const rep_types = fg.get('rep_types').value;
  const days_notify = fg.get('days_notify').value;


  // return repeat_period !== null && days_notify !== null && repeat_period < days_notify
  //   ? null
  //   : { range: true };

  var sa;
  if (repeat_period != "") {
     sa = fg.get('repeat_period').value;
  }
  
  var sb = rep_types;
  if (sb == "week") {
    sa = sa * 7;
  }
  else if (sb == "months") {
    sa = sa * 30;
  }
  else if (sb == "years") {
    sa = sa * 365;
  }

  var common = new Date();

  var first = new Date();
  first.setDate(common.getDate() + parseInt(sa)); 

  var second = new Date();
  second.setDate(common.getDate() + parseInt(days_notify)); 
  return first > second  ? null   : { range: true };
};


@Component({
  selector: 'app-document-repetition',
  templateUrl: './document-repetition.component.html',
  styleUrls: ['./document-repetition.component.css']
})
export class DocumentRepetitionComponent implements OnInit {

  @Input() ID: string;
  @Input() langs: string;
  @ViewChild('imagePreviewRef') imagePreviewRef: ElementRef;
  typePeriod: any;
  timeNotify: any;
  modalTitle: string;

  lang: any;
  record: any;
  mode: string;
  doc_id: any;

  imageLink: any;
  
  createForm: FormGroup;
  createFormSubmitted: Boolean = false;
  createFormErrorMsg: any;
  occ_details: any;
  deadline_id: any;
  notification_time: any;
  rolepermission: any;

  id: number;


  
  constructor(
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private generalService: GeneralService,
    private deadlineService: DeadlineService,
    private documentmangService: DocumentMangService,
    private ngxRolesService: NgxRolesService,

    private router: Router,
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
  ) { }

  ngOnInit() {
       
    var role = this.ngxRolesService.getRole('doc_management');
    
    this.rolepermission = '';
    if (role) {
      this.rolepermission = role.validationFunction[0];
    }

    this.FormBuild();
    this.getData();

    this.config();
    this.fileDesign();
  }

  config(): void {        
    this.typePeriod = [
      { value: 'days', text: 'Days' },
      { value: 'week', text: 'Week' },
      { value: 'months', text: 'Month' },
      { value: 'years', text: 'Year' }
    ];
  }

  FormBuild(): void {
    
    this.createForm = this.formBuilder.group({
      start_days: ['', [Validators.required]],
      repeat_period: ['', [Validators.required]],
      rep_types: ['', [Validators.required]],
      days_notify: ['', [Validators.required]],
      notify_time: ['', [Validators.required]],
      send_email: this.formBuilder.array([this.newEmail()]),
      doc_id: [''],
      occurrence_id: [''],      
      action: 'update'
    }, { validator: MyAwesomeRangeValidator });

    this.createFormErrorMsg = {
      'start_days': [{ type: 'required', message: 'This field is Required' }],
      'repeat_period': [{ type: 'required', message: 'This field is Required' }],
      'rep_types': [{ type: 'required', message: 'This field is Required' }],
      'days_notify': [{ type: 'required', message: 'This field is Required' }],
      'notify_time': [{ type: 'required', message: 'This field is Required' }],
      'send_email': [
        { type: 'required', message: 'This field is Required' },
      { type: 'email', message: 'Please enter correct email format' }],

    }    

  }

  FormBuildUpdate(): void {
    
    this.emptyEmail();
    let emails = this.occ_details.send_email.split(',');


    this.createForm.patchValue({
      start_days: this.occ_details.start_days,
      repeat_period: this.occ_details.repeat_period,
      rep_types: this.occ_details.rep_types,
      days_notify: this.occ_details.days_notify,
      notify_time: this.occ_details.notify_time,
      doc_id: this.occ_details.doc_id,
      occurrence_id: this.occ_details.occurrence_id,
    });

    if(this.occ_details.send_email) {
      for (const email of emails) {
        this.send_email().push(this.newEmail(email));
      }
    }
    else
      this.send_email().push(this.newEmail());



  }

  send_email() : FormArray {
    return this.createForm.get("send_email") as FormArray
  }
   
  newEmail(data = ''): FormControl {
    return new FormControl(data, [Validators.required,Validators.email]);
  }
   
  addEmail() {
    this.send_email().push(this.newEmail());
  }
   
  removeEmail(i:number) {
    this.send_email().removeAt(i);
  }

  emptyEmail() {
    while (this.send_email().controls.length > 0) {
      this.send_email().removeAt(0);
    }
  }

  fileDesign(){
    $(".filestyle").filestyle({
      'htmlIcon': '<i class="fa fa-inbox mr-5"></i>',
      'btnClass': 'btn-default',
    });
  }

  formErrorClass(value, submitted): string {
    return value.errors && (value.touched || value.dirty || submitted) ? 'error-border' : '';
  }

  imagePreview(value) {

    this.imageLink = value;
    this.modalService.show(this.imagePreviewRef, { class: 'modal-lgs' });

  }

  onSubmit() {

    this.createFormSubmitted = true;

    if (this.createForm.invalid)
      return;
    
    this.documentmangService.updateOccurrence(this.createForm.value).subscribe(
      res => {

        if (res.status) {
          this.generalService.notify_msg('success', res.msg);
          this.bsModalRef.hide();
          
          this.router.navigateByUrl('/test', { skipLocationChange: true })
            .then(() => {
              this.router.navigate([AppFrontRoutes.DOCUMENTMANG_VIEW+'/'+this.doc_id]);
          });
        }
        else {
          this.generalService.notify_msg('error', res.msg);
          this.bsModalRef.hide();
        }

      }
    );

  }

  getData() {
    // alert('test'); return false;
    // console.log(this.ID); return false;
    if (this.ID != "") {

      // console.log(this.ID);

      this.documentmangService.view(this.ID)
        .subscribe(
          (res) => {
       
            this.lang = this.documentmangService.listLang(res);
            this.doc_id = res.data.doc_id;
            this.occ_details = res.data.occ_details;
            this.notification_time = res.data.notification_time;

              this.FormBuildUpdate();
      
          }
        );
    }
    else {
      // console.log('test');

      this.lang = this.langs;
      this.mode = 'Set';
      this.modalTitle = 'SET OCCURRENCE';
    }

  }
}
